// 生成一个随机数
export function MathRandom(){
    return Math.random()*20
}